import { createForm } from 'shared-ui/lib/customs/form/FormGenerator';
import { FormInput } from 'shared-ui/lib/customs/form/FormInput';
import { userInput } from '../inputs/user.input';

const editForm: FormInput[] = [userInput.name, userInput.email];

export const userEditForm = createForm(editForm);

export type UserFormBody = {
  name: string;
  email: string;
};
